import type { QueryClient } from '@tanstack/react-query';
import { QueryKeys } from 'api/queryKeys';
import { patentDraftQueryKeys } from 'features/PatentDrafting/api/queryKeys';
import { useEventListener } from 'usehooks-ts';
import { hasKeptUploadFailures } from 'utils/keptUploadFailures';

const UPLOAD_MUTATION_KEYS: unknown[] = [
  QueryKeys.uploadFile,
  QueryKeys.batchCreateDraftCompounds,
  QueryKeys.batchCreateSequences,
  QueryKeys.importSequences,
  patentDraftQueryKeys.uploadPatentDraftFile,
];

export const useBlockUnload = (queryClient: QueryClient) => {
  'use memo';

  useEventListener('beforeunload', event => {
    const isUploading =
      queryClient.isMutating({ predicate: ({ options }) => UPLOAD_MUTATION_KEYS.includes(options.mutationKey?.[0]) }) >
      0;
    if (isUploading || hasKeptUploadFailures(queryClient)) event.preventDefault();
  });
};
